// libraries
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { apiOrchestratorPricingCommittee } from '@store/apiSlices/apiSlices';

// interfaces
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import { CountryCode } from '@domains/country';
import { IStatusCountsResponse } from '../../interfaces/interfaces';

export const orchestratorStatusCountsApi =
  apiOrchestratorPricingCommittee.injectEndpoints({
    endpoints: builder => ({
      getStatusCounts: builder.query<
        Record<string, number>,
        {
          country?: CountryCode;
          start_date?: string;
          end_date?: string;
          workflow_alias?: string;
        }
      >({
        query: params => ({
          url: '/retrieve-orchestrator-status-count',
          params,
        }),
        transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
          const modelError: ModelError = {
            errorStatus: error.status,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            messageFromServer: (error.data as any)?.message,
            serviceErrorName: 'getStatusCounts',
          };
          return modelError;
        },
        transformResponse: (
          response: IStatusCountsResponse
        ): Record<string, number> => {
          return response.counts;
        },
        providesTags: (
          result,
          error,
          { country, start_date, end_date, workflow_alias }
        ) => [
          {
            type: 'CurrentOrchestrator' as const,
            id: `${country ?? 'all'}:counts:${start_date ?? ''}:${end_date ?? ''}:${workflow_alias ?? ''}`,
          },
        ],
      }),
    }),
  });

export const { useGetStatusCountsQuery } = orchestratorStatusCountsApi;
